<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'GPSウォーク／ランイベント'">
          <list-item :spanText="'Q. '" :text="'参加中の複数のイベントを見る方法'" :urlName="'Help36'"></list-item>
          <list-item :spanText="'Q. '" :text="'参加中のイベントを退出したい'" :urlName="'Help37'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory21.vue